import {XauditModel} from '../../../models/xaudit.model';

export class PainEndoDetailDataModel extends XauditModel {
  PainDetailID: string;
  PainID: string;
  isItemSelected: boolean;
  enumEndoPainSymptomID: string;
  ItemOrder: number;
  enumEndoPainOnsetID: string;
  enumEndoPainIncidenceID: string;
  enumEndoPainBSeverity: string;
  enumEndoPainLSeverity: string;
  enumEndoPainDurationID: string;
  enumEndoPainCourseID: string;
  enumEndoPainFrequencyID: string;
}
